export default "__VITE_ASSET__DopM0zom__"